import React from "react";
import dayjs from "dayjs";
import { LocalizationProvider, MobileTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ThemeProvider, createTheme } from "@mui/material/styles";

/* ==============================
   PREMIUM MATERIAL THEME
================================ */
const theme = createTheme({
  palette: {
    primary: {
      main: "#FB6742",
    },
  },
  typography: {
    fontFamily: "Inter, sans-serif",
  },
  components: {
    MuiPickersLayout: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFFFFF",
          borderRadius: 24,
          boxShadow: "0 30px 60px rgba(0,0,0,0.12)",
        },
      },
    },
    MuiClock: {
      styleOverrides: {
        root: {
          backgroundColor: "#FAFAFA",
          borderRadius: 20,
        },
      },
    },
    MuiPickersToolbar: {
      styleOverrides: {
        root: {
          background:
            "linear-gradient(135deg, rgba(251,103,66,0.08), rgba(251,103,66,0.02))",
          borderBottom: "1px solid #F1F1F1",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 14,
          fontWeight: 600,
          textTransform: "none",
        },
      },
    },
  },
});

/* ==============================
   MAIN COMPONENT (UNCHANGED API)
================================ */
const TimeRangePicker12 = ({
  label = "",
  variant = "range",
  startTime,
  endTime,
  onStartChange,
  onEndChange,
  value, 
  onChange,  
}) => {
  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <div className="group  relative w-full rounded-3xl p-[1px] bg-gray-50 transition-all duration-300">
          <div className=" ">
            {label && (
              <label className="text-sm font-semibold text-gray-900 mb-4 block tracking-tight">
                {label}
              </label>
            )}

            {variant === "range" ? (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <ClockPicker
                  label="From"
                  value={startTime}
                  onChange={onStartChange}
                />
                <ClockPicker
                  label="To"
                  value={endTime}
                  onChange={onEndChange}
                />
              </div>
            ) : (
              <ClockPicker label={label} value={value} onChange={onChange} />
            )}
          </div>
        </div>
      </LocalizationProvider>
    </ThemeProvider>
  );
};

/* ==============================
   SINGLE CLOCK PICKER (PREMIUM)
================================ */

const ClockPicker = ({ label, value, onChange }) => {
  const parsedValue = value?.hour
    ? dayjs(`${value.hour}:${value.minute} ${value.period}`, "hh:mm A")
    : dayjs();

  return (
    <MobileTimePicker
      label={label}
      value={parsedValue}
      onChange={(val) => {
        if (!val) return;

        onChange({
          hour: val.format("hh"),
          minute: val.format("mm"),
          period: val.format("A"),
        });
      }}
      ampm
      closeOnSelect={false}
      slotProps={{
        textField: {
          size: "small",
          sx: {
            width: "100%",
            "& .MuiOutlinedInput-root": {
              borderRadius: "20px",
              backgroundColor: "#F9FAFB",
              fontSize: "13px",
              transition: "all 0.25s ease",
              height: "56px",

              "& fieldset": {
                borderColor: "#E5E7EB",
                fontSize: "10px",
              },

              "&:hover": {
                backgroundColor: "#FFFFFF",
                transform: "translateY(-1px)",
              },

              "&:hover fieldset": {
                borderColor: "#FDB8A5",
              },

              "&.Mui-focused": {
                backgroundColor: "#FFFFFF",
              },

              "&.Mui-focused fieldset": {
                borderColor: "#FB6742",
                borderWidth: "2px",
                boxShadow: "0 0 0 6px rgba(251,103,66,0.12)",
              },
            },

            "& .MuiInputBase-input": {
              padding: "14px 16px",
              fontSize: "10px",
              fontWeight: 500,
              color: "#0049D9",
              letterSpacing: "0.2px",
            },
          },
        },
      }}
    />
  );
};

export default TimeRangePicker12;
